import React from 'react'
import PropTypes from 'prop-types'

export const Button = ({ id, mode, addToPool, removeFromPool }) => {
  if (mode === 'remove') {
    return (
      <button
        name="btnRemoveFromPool"
        id={'AddRemoveButton-' + id}
        onClick={() => removeFromPool({ restaurantId: id })}
        className="btn btn-sm btn-primary"
      >
        Remove
      </button>
    )
  }
  if (mode === 'add') {
    return (
      <button
        name="btnAddToPool"
        id={'AddRemoveButton-' + id}
        onClick={() => addToPool({ restaurantId: id })}
        className="btn btn-sm btn-primary"
      >
        Add to pool
      </button>
    )
  }
  return null
}

Button.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  mode: PropTypes.oneOf(['add','remove']).isRequired,
  addToPool: PropTypes.func,
  removeFromPool: PropTypes.func
}

Button.defaultProps = {
  addToPool: () => {},
  removeFromPool: () => {}
}

export default Button



// WEBPACK FOOTER //
// ./src/containers/pools/details/restaurants/button.js